import {useQuery} from "react-query";
import Alert from "react-s-alert";
import {ResidentService} from "../../../services/ResidentServices";

export const useFetchResident = (resident_uuid?: string) => {
  return useQuery(
    ["fetch_resident"],
    async () => {
      const {data} = await ResidentService.getOneResident(resident_uuid);

      return data;
    },
    {
      enabled: !!resident_uuid,
      onError: () => Alert.error("Failed to load resident"),
      refetchOnMount: true,
    },
  );
};
